import Request from 'src/utils/request';
import { serializeError } from 'serialize-error';
import packageInfo from '../../package.json';

const version = packageInfo.version as string;
const R = new Request();

enum LoadDataError {
    FailedToLoadCallInfo = 'LD-001',
    FailedToCreateParticipant = 'LD-002',
    FailedToDecryptPayload = 'LD-003',
    PayloadIsNotValid = 'LD-004',
    CallRequestFailed = 'LD-005',
    FailedToGetCallReasons = 'LD-006',
    FailedToSetAppointment = 'LD-007',
    FailedToGetSource = 'LD-008',
    FailedToInjectAnalyticsScript = 'LD-009',
}

type ErrorCode = LoadDataError;

async function registerAppError(errorId: ErrorCode, error: any): Promise<void>;
async function registerAppError(errorId: ErrorCode, errorMessage: string): Promise<void>;
async function registerAppError(errorId: ErrorCode, errorOrErrorMessage: any): Promise<void> {
    const errorMessage = getErrorMessage(errorOrErrorMessage);
    const errorObject = getErrorObject(errorOrErrorMessage);
    const body = {
        errorMessage,
        errorObject,
    };

    const data = {
        id: errorId,
        source: 'CLIENT',
        appVersion: version,
        userAgent: window.navigator.userAgent,
        callHash: window.callHash,
        body: JSON.stringify(body)
    };

    try {
        await R.callBrokerApi({
            controller: '/log/sendAppError',
            data,
        });
    } catch (e) {
        console.error(e);
    }
}

function getErrorMessage(errorOrErrorMessage: any): string {
    if (!errorOrErrorMessage) {
        return '';
    }

    if (typeof errorOrErrorMessage === 'string') {
        return errorOrErrorMessage;
    }

    return errorOrErrorMessage.message as string;
}

function getErrorObject(errorOrErrorMessage: any) {
    if (typeof errorOrErrorMessage === 'string') {
        return null;
    }

    return serializeError(errorOrErrorMessage);
}

export {
    registerAppError,
    LoadDataError,
};
